import AllVendorsList from '@/modules/vendors/components/index';
import { ROUTES } from '@/shared/constants/routes';
import { RouteObject } from 'react-router-dom';

export const VendorsRoutes: RouteObject[] = [
  {
    path: ROUTES.VENDORS,
    Component: AllVendorsList,
    children: [],
  },
];
